function kebabCaseToCamel(str) {
  return str.replace(/(\-\w)/g, (matches) => matches[1].toUpperCase());
}

class API {
  constructor({ url }) {
    this.url = url;
    this.endpoints = {};
  }

  /**
   * Create and store a single entity's endpoints
   * @param {A entity Object} entity
   */
  createEntity(entity) {
    /**
     * If there is a - in the entity.name, then change it
     * to camelCase. E.g
     * ```
     * myApi.createEntity({ name : 'foo-bar'})
     * myApi.endpoints.fooBar.getAll(...)
     */

    const name = kebabCaseToCamel(entity.name);
    this.endpoints[name] = this.createBasicCRUDEndpoints(entity);
  }

  createEntities(arrayOfEntity) {
    arrayOfEntity.forEach(this.createEntity.bind(this));
  }

  /**
   * Create the basic endpoints handlers for CRUD operations
   * @param {A entity Object} entity
   */
  createBasicCRUDEndpoints({ name }) {
    const endpoints = {};

    const resourceURL = `${this.url}/${name}`;

    endpoints.post = (body) =>
      fetch(resourceURL, {
        crossDomain: true,
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
      });

    endpoints.postAsync = (body) => async () => {
      const response = await fetch(resourceURL, {
        crossDomain: true,
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
      });
      if (response.redirected) {
        window.location.replace(response.url);
      }
      if (!response.ok) {
        throw new Error(`Failed to fetch: ${resourceURL}`);
      }
      return response.json();
    };

    endpoints.postAndProcess = (body) =>
      fetch(resourceURL, {
        crossDomain: true,
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
      }).then((response) => {
        if (!response.ok) {
          throw new Error(`Failed to post: ${resourceURL}`);
        }
        return response.json();
      });

    endpoints.postLogBody = (body) => {
      //console.log(body, JSON.stringify(body));
      return fetch(resourceURL, {
        crossDomain: true,
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
      });
    };

    endpoints.postNoStringify = (body) =>
      fetch(resourceURL, {
        crossDomain: true,
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body,
      });

    endpoints.postID = (ID) =>
      fetch(`${resourceURL}/${ID}`, {
        crossDomain: true,
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      });

    endpoints.postSingleQueryString = (queryParam, queryVal) =>
      fetch(`${resourceURL}?${queryParam}=${queryVal}`, {
        crossDomain: true,
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      });

    endpoints.postMultipleQueryString = (queries) =>
      fetch(
        `${resourceURL}?${queries
          .map((currentValue, index, array) => {
            if (array.length - 1 == index) {
              return `${currentValue.queryParam}=${currentValue.queryVal}`;
            }
            return `${currentValue.queryParam}=${currentValue.queryVal}&`;
          })
          .join('')}`
      );

    endpoints.postMultipleQueryStringAsync = (queries) => async () => {
      const response = await fetch(
        `${resourceURL}?${queries
          .map((currentValue, index, array) => {
            if (array.length - 1 === index) {
              return `${currentValue.queryParam}=${currentValue.queryVal}`;
            }
            return `${currentValue.queryParam}=${currentValue.queryVal}&`;
          })
          .join('')}`
      );
      if (!response.ok) {
        throw new Error(`Failed to fetch: ${resourceURL}`);
      }
      return response.json();
    };

    return endpoints;
  }
}

export default API;
